@defer {
<div class="thumbs">
  <div
    [ngClass]="{ active: _media === media }"
    class="thumb"
    (click)="_media = media"
    *ngFor="let media of _medias ? _medias : product?.media"
  >
    <ng-container *ngIf="media?.mediaContentType == 'VIDEO'">
      <img
        *ngIf="media?.preview?.image?.url"
        [alt]="media.alt"
        width="52"
        height="42"
        [loaderParams]="{ aspect: 1.24 }"
        [ngSrc]="media?.preview?.image?.url"
      />
    </ng-container>

    <ng-container *ngIf="media?.mediaContentType == 'IMAGE'">
      <img
        *ngIf="media?.image?.url"
        [alt]="media.alt"
        width="52"
        height="42"
        [loaderParams]="{ aspect: 1.24 }"
        [ngSrc]="media.image?.url"
      />
    </ng-container>
  </div>
</div>
} @placeholder {
<div></div>
}
<app-carousel
  *ngIf="product?.media"
  [selected]="_media?.id"
  [options]="options"
  class="d-lg-none"
>
  <ng-container
    *ngFor="let media of _medias ? _medias : product?.media; let first = first"
  >
    <ng-container *ngIf="media?.mediaContentType == 'VIDEO'">
      <video
        [attr.data-id]="media.id"
        autoplay
        muted
        [poster]="media?.preview?.image?.url"
        width="100%"
      >
        <source
          *ngFor="let source of media?.sources"
          [src]="source.url"
          [type]="source.mimeType"
        />
        Your browser does not support the video tag.
      </video>
    </ng-container>
    <ng-container *ngIf="media?.mediaContentType == 'IMAGE'">
      <img
        [attr.data-id]="media.id"
        [alt]="media.alt"
        class="w-100 h-auto"
        width="741"
        height="600"
        [priority]="first"
        ngSrcset="400w, 800w, 1200w"
        [ngSrc]="media.image.url"
      />
    </ng-container>
  </ng-container>
</app-carousel>
<div class="media d-lg-flex d-none">
  <ng-container *ngIf="_media?.mediaContentType === 'VIDEO'">
    <video
      [attr.data-id]="_media.id"
      autoplay
      muted
      [poster]="_media?.preview?.image?.url"
      width="100%"
    >
      <source
        *ngFor="let source of _media?.sources"
        [src]="source.url"
        [type]="source.mimeType"
      />
      Your browser does not support the video tag.
    </video>
  </ng-container>
  <ng-container *ngIf="_media?.mediaContentType == 'IMAGE'">
    <img
      [attr.data-id]="_media.id"
      priority
      class="hero w-100 h-auto"
      width="741"
      height="600"
      [alt]="_media.alt"
      *ngIf="_media?.image.url"
      [ngSrc]="_media.image.url"
      ngSrcset="400w, 800w, 1200w"
    />
  </ng-container>
</div>
